<template>
  <div>
    <div class="title">
      <div class="viewName">权限管理</div>
      <el-button type="primary" @click="createJurisdiction" v-show='show'>创建权限</el-button>
    </div>
    <div class="content">
      <el-form :inline="true" :model="queryParam" ref="queryParam">
        <el-form-item label="产品名称" prop="productName" class="contentItem">
          <el-select
            v-model="queryParam.productName"
            placeholder="请选择产品名称"
            @change="queryList()"
          >
            <el-option
              v-for="item in productList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
              >{{ item.label }}</el-option
            >
          </el-select>
        </el-form-item>
      </el-form>
      <div class="mytablediv">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ background: '#F1F4F9' }"
        >
          <el-table-column
            align="center"
            prop="productName"
            label="产品名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="权限名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="keyData"
            label="权限key名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="description"
            label="备注"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <div style="display: inline-flex">
                <div class="view" @click="view(scope.row)">查看</div>
                <div class="edit" @click="edit(scope.row)">编辑</div>
                <div class="del" @click="delPermisson(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <my-pages
          :total="total"
          :page-size="pageSize"
          @handleSizeChangeSub="handleSizeChangeFun"
          @handleCurrentChangeSub="handleCurrentChangeFun"
        ></my-pages>
      </div>

      <el-dialog
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        class="dialogContainer"
        @open="resetFields('form')"
      >
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item
            label="产品名称："
            label-width="140px"
            prop="productName"
          >
            <el-select v-model="form.productName" class="formItem" disabled>
              <el-option
                label="台架测试数据生成系统"
                value="台架测试数据生成系统"
              ></el-option>
              <el-option label="Web-UI" value="Web-UI"></el-option>
              <el-option label="德清测试系统" value="德清测试系统"></el-option>
              <el-option
                label="X-Cloud云平台"
                value="X-Cloud云平台"
              ></el-option>
              <el-option
                label="感知数据测试工具"
                value="感知数据测试工具"
              ></el-option>
              <el-option label="CDAS" value="CDAS"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限名称：" label-width="140px" prop="name">
            <el-input
              :disabled="disabled"
              v-model="form.name"
              class="formItem"
              placeholder="可读性强的名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="权限Key：" label-width="140px" prop="keyData">
            <el-input
              :disabled="disabled"
              v-model="form.keyData"
              class="formItem"
              placeholder="可研发已经确认的唯一标识代码"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" label-width="140px">
            <el-input
              :disabled="disabled"
              v-model="form.description"
              class="formItem"
            ></el-input>
          </el-form-item>
        </el-form>
        <div v-if="message !== ''" class="errorMessage">{{ message }}</div>
        <el-button
          :disabled="isDisabled"
          type="primary"
          class="footerSubmitButton"
          @click="create('form')"
          >确定</el-button
        >
        <el-button class="footerCancelButton" @click="cancel">取消</el-button>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import myPages from "@/components/Commonpaging/Pagination";
import {
  queryPermission,
  createPermission,
  deletePermission,
  upDatePermission,
  getProduct
} from "@/api/quanxianguanli/quanxian";
export default {
  name: "quanxiantable",
  data() {
    return {
      dialogFormVisible: false,
      isDisabled: false,
      type: "1",
      show:true,
      disabled: false,
      message: "",
      total: 0, //默认数据总数
      pageSize: 10, //每页数据条数
      currentPage: 1, //默认开始页面
      queryParam: {
        productName: "",
      },
      form: {
        productName: "",
        name: "",
        keyData: "",
        description: "",
      },
      rules: {
        productName: [
          {
            required: true,
            message: "请选择产品名称",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入权限名称",
            trigger: "change",
          },
        ],
        keyData: [
          {
            required: true,
            message: "请输入权限Key",
            trigger: "change",
          },
        ],
      },
      tableData: [],
      productList: [
      ],
    };
  },
  components: {
    myPages,
  },
  mounted() {
    // this.queryList();
    this.queryProduct();
  },
  created() {
    // this.queryParam.productName = this.productList[0].value;
  },
  methods: {
    //查询名称列表
    queryProduct(){
      getProduct().then((res) => {
        if(res.status == 0){
          if(res.result.length>0){
            res.result.map(item => {
              item.label = item.productName,
              item.value = item.productId
            })
            this.productList = res.result;
            this.queryParam.productName = res.result[0].value||null
          }else{
            this.show = false;
            // this.$message({
            //   message:'此账户无权限!',
            //   duration:0,
            //   type:'error'
            // })
          }
        }
      }).then(() => {
        this.queryList();
      })
    },
    //查询权限列表
    queryList() {
      let formData = new FormData();
      formData.append("pageNum", this.currentPage);
      formData.append("pageSize", this.pageSize);
      formData.append("productName", this.queryParam.productName);
      queryPermission(formData).then((res) => {
        if (res.status === 0) {
          var result = res.result;
          this.tableData = res.result.list;
          this.currentPage = result.pageNum; //当前页
          this.total = result.total; //总页码
          this.tableData = result.list;
        }
      });
    },
    //查看
    view(row) {
      this.dialogFormVisible = true;
      this.disabled = true;
      this.type = "3";
      this.$nextTick(() => {
        this.form.productName = row.productName;
        this.form.name = row.name;
        this.form.keyData = row.keyData;
        this.form.description = row.description;
      });
    },
    //编辑
    edit(row) {
      this.dialogFormVisible = true;
      this.type = "2";
      this.disabled = false;
      this.$nextTick(() => {
        this.form.productName = row.productName;
        this.form.name = row.name;
        this.form.keyData = row.keyData;
        this.form.description = row.description;
        this.form.id = row.id;
      });
    },
    //新建 修改
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.type === "1") {
            this.isDisabled = true;
            let params = {
              productName: this.form.productName,
              name: this.form.name,
              keyData: this.form.keyData,
              description: this.form.description,
            };
            createPermission(params).then((res) => {
              if (res.status === 0) {
                this.$message({
                  message: "创建成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.queryList();
                this.isDisabled = false;
              } else {
                this.$message({
                  message: "创建失败",
                  type: "error",
                });
                this.dialogFormVisible = true;
                this.message = res.message;
              }
            });
          } else if (this.type == "2") {
            let params = {
              id: this.form.id,
              productName: this.form.productName,
              name: this.form.name,
              keyData: this.form.keyData,
              description: this.form.description,
            };
            upDatePermission(params).then((res) => {
              if (res.status === 0 && res.result === true) {
                this.$message({
                  message: "更新成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.form.description = "";
                this.form.productName = "";
                this.form.name = "";
                this.form.keyData = "";
                this.queryList();
                // this.isDisabled = false
              } else {
                this.$message({
                  message: "更新失败",
                  type: "error",
                });
                this.dialogFormVisible = true;
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //删除权限
    delPermisson(row) {
      let arr = [
        "是否删除权限'" + row.name + "'?",
        "将在所有已创建的许可证中删除该权限",
      ];
      let str = arr.join(" <br/> ");
      this.$confirm(str, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        customClass: "messageBox",
        // type: "warning",
      })
        .then(() => {
          this.endroad(row);
        })
        .catch(() => {
          // 取消点击事件
        });
    },
    //删除权限 调用接口
    endroad(row) {
      let formData = new FormData();
      formData.append("id", row.id);
      deletePermission(formData).then((res) => {
        if (res.status === 0) {
          this.$message.success("删除成功");
          this.queryList();
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    // 每页展示条数
    handleSizeChangeFun(v) {
      this.pageSize = v;
    },
    // 当前页
    handleCurrentChangeFun(v) {
      //页面点击
      this.currentPage = v; //当前页
      this.queryList();
    },
    //新建 弹框
    createJurisdiction() {
      this.dialogFormVisible = true;
      this.disabled = false;
      this.type = "1";
      this.$nextTick(() => {
        this.form = {
          productName: this.queryParam.productName,
          name: "",
          keyData: "",
          description: "",
        };
      });
    },
    //清除表单
    resetFields(form) {
      if (this.type == "1") {
        this.$nextTick(() => {
          this.$refs[form].resetFields();
        });
      }
    },
    //取消
    cancel() {
      this.dialogFormVisible = false;
      this.form.keyData = "";
      this.form.productName = "";
      this.form.name = "";
      this.form.description = "";
      this.message = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  height: 60px;
  background: #ffffff;
  border: 0 solid #d5d5d5;
  border-radius: 12px;
  position: relative;
}
.viewName {
  font-size: 18px;
  color: #4880ff;
  letter-spacing: 0;
  line-height: 60px;
  font-weight: 500;
  position: absolute;
  left: 23px;
}
.el-button {
  font-size: 14px;
  background: #4379ee;
  position: absolute;
  right: 14px;
  top: 11px;
}
.content {
  background: #ffffff;
  overflow: auto;
  border-radius: 14px;
  margin-top: 10px;
  position: relative;
  padding-left: 16px;
  padding-right: 16px;
}
.contentItem {
  position: absolute;
  left: 23px;
  top: 27px;
}
.mytablediv {
  margin-top: 95px;
}
.view {
  width: 38px;
  height: 22px;
  border: 1px solid #4379ee;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
}
.edit {
  width: 38px;
  height: 22px;
  border: 1px solid #4379ee;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  margin-left: 5px;
}
.del {
  width: 38px;
  height: 22px;
  border: 1px solid #4379ee;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  margin-left: 5px;
}
.el-dialog {
  width: 663px;
  border-radius: 26px;
}
.el-pagination {
  float: left !important;
}
.formItem {
  width: 459px;
}
.footerSubmitButton {
  position: relative;
  bottom: 20px;
  left: 100px;
  width: 130px;
  background: #4880ff;
  border-radius: 6px;
}
.footerCancelButton {
  position: relative;
  bottom: 20px;
  left: 250px;
  width: 130px;
  border-radius: 6px;
  background: #d8d8d8;
  color: #fff;
}
.footerCancelButton:hover {
  background: #d8d8d8;
  color: #fff;
}
.errorMessage {
  margin-top: 18px;
  margin-bottom: 18px;
  text-align: center;
  color: #fa5555;
}
</style>
<style lang='scss'>
.dialogContainer .el-dialog {
  width: 663px;
  border-radius: 26px;
}
.contentItem .el-form-item__label {
  font-size: 16px !important;
  color: #404040 !important;
  letter-spacing: 0;
  font-weight: 400;
}
.messageBox {
  width: 663px !important;
  height: 315px !important;
  position: relative;
  border-radius: 26px;
}
.messageBox .el-message-box__message {
  position: absolute;
  top: 100px;
  left: 171px;
  text-align: center;
  font-size: 16px;
  color: #202224;
  letter-spacing: 0;
}
.messageBox .el-message-box__btns .el-button--default {
  position: absolute;
  bottom: 26px;
  right: 126px;
  width: 130px;
  height: 35.9px;
  background: #d8d8d8;
  border-radius: 6px;
  color: #fff;
}
.messageBox .el-message-box__btns .el-button--default:hover {
  position: absolute;
  bottom: 26px;
  right: 126px;
  width: 130px;
  height: 35.9px;
  background: #d8d8d8;
  border-radius: 6px;
  color: #fff;
}
.messageBox .el-message-box__btns .el-button--primary {
  position: absolute;
  bottom: 26px;
  left: 146px;
  background: #4880ff;
  border-radius: 6px;
}
.messageBox .el-message-box__btns .el-button--primary:hover {
  position: absolute;
  bottom: 26px;
  left: 146px;
  background: #4880ff;
  border-radius: 6px;
}
.messageBox .el-message-box__headerbtn {
  background: url("../../../assets/icon_error.png") !important;
  background-size: 100% 100%;
  width: 21px !important;
  height: 21px !important;
}
.messageBox .el-icon-close {
  display: none !important;
}
.dialogContainer .el-dialog__headerbtn {
  background: url("../../../assets/icon_error.png") !important;
  background-size: 100% 100%;
  width: 21px !important;
  height: 21px !important;
}
.dialogContainer .el-icon-close {
  display: none !important;
}
</style>